export function detectMedia () {
    function bty_detectMedia() {
        let dir = '/wp-content/themes/betterthanyou/css/';

        if (window.matchMedia('(max-width: 767px)').matches) {
            bty_removeJsCssFile('desktop', 'css');
            bty_removeJsCssFile('tablet', 'css');
        } else if (window.matchMedia('(max-width: 768px)').matches) {
            bty_removeJsCssFile('desktop', 'css');
            bty_loadFile(dir, 'tablet');
        } else if (window.matchMedia('(max-width: 1199px)').matches) {
            bty_loadFile(dir, 'tablet');
            bty_loadFile(dir, 'desktop');
        } else {
            bty_loadFile(dir, 'tablet');
            bty_loadFile(dir, 'desktop');
        }
    }

    function bty_loadFile(dir, match) {
        let ss = document.styleSheets;
        for (let i = 0, max = ss.length; i < max; i++) {
            if (ss[i].href !== null && ss[i].href === document.location.origin + dir + match + '.css') {
                return;
            }
        }

        let link = document.createElement('link');
        link.href = dir + match + '.css';
        link.type = 'text/css';
        link.rel = 'stylesheet';
        link.media = 'screen,print';
        document.getElementsByTagName('head')[0].appendChild(link);
    }

    function bty_removeJsCssFile(fibtyme, filetype) {
        let el = (filetype === 'js') ? 'script' : (filetype === 'css') ? 'link' : 'none';
        let attr = (filetype === 'js') ? 'src' : (filetype === 'css') ? 'href' : 'none';
        let tags = document.getElementsByTagName(el);
        for (let i = tags.length; i >= 0; i--) {
            if (tags[i] && tags[i].getAttribute(attr) != null && tags[i].getAttribute(attr).indexOf(fibtyme) !== -1) {
                tags[i].parentNode.removeChild(tags[i]);
            }
        }
    }

    //init
    document.addEventListener('DOMContentLoaded', function () {
        bty_detectMedia();
    });
    window.onresize = bty_detectMedia;
};
